export default __webpack_public_path__ + "static/media/plug-disabled.af36586e.svg";